import { render } from "./PensionCreditsHistory.vue?vue&type=template&id=6bb625fd&ts=true"
import script from "./PensionCreditsHistory.vue?vue&type=script&lang=ts"
export * from "./PensionCreditsHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__